import { Flex } from '@cognite/cogs.js-v10';
import styled from 'styled-components';

export const FullHeightWrapper = styled(Flex).attrs({
  direction: 'column',
})`
  height: 100%;
`;
